import { useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/** Organisation, store and personal shortcuts usable on this store. */
export function useChatShortcuts(storeId: string, enabled = true) {
  return useQuery({
    queryKey: conversationKeys.shortcuts(storeId),
    queryFn: () => conversationsApi.shortcuts(storeId),
    staleTime: 60_000,
    enabled,
  });
}
